import React, { useState, useEffect, useMemo } from 'react'
import { useNavigate } from '@tanstack/react-location'
import { events, posttour } from 'shared/analytics'
import { sort } from 'shared/helpers/general'

import { useStore } from 'TourApp/store'
// Components
import MosaicView from './MosaicView'
import DVT from 'shared/assets/images/default-video-thumbnail.png'
import { getCdnAssetUrl } from 'shared/helpers/assets'

const AtomicMedia = ({ src, setDimensions, ...props }) => {
  const onImgLoad = ({ target: img }) => {
    setDimensions({
      height: img.naturalHeight,
      width: img.naturalWidth,
    })
  }

  return <img onLoad={onImgLoad} src={src} alt="" {...props} />
}

export default function PhotosScreen() {
  const { tourData, selectedApartmentId } = useStore()
  const [photos, setPhotos] = useState([])
  const navigate = useNavigate()
  const apartment = tourData.units.find(({ unit }) => unit.id === selectedApartmentId)
  const PHOTOS = useMemo(() => {
    return apartment.photos
  }, [apartment])
  const VIDEOS = useMemo(() => {
    return tourData.videos.map((v) => ({
      ...v,
      // `src` uses for Mosaic view. Should always be an image
      src: v.thumbnail.includes('.mp4') ? DVT : v.thumbnail,
      videoSrc: v.src,
    }))
  }, [tourData])

  const getMediaProps = (media) =>
    media.isVideo ? { video_id: media.id, video_file_name: media.videoSrc } : { image_id: media.id }

  useEffect(() => {
    setPhotos([])
  }, [selectedApartmentId])

  useEffect(() => {
    if (PHOTOS.length === 0 && VIDEOS.length === 0) {
      navigate({ to: '/gallery' })
    }
  }, [PHOTOS, VIDEOS, navigate])

  return (
    <>
      <div className="hidden">
        {[...VIDEOS, ...PHOTOS].map((media) => (
          <AtomicMedia
            key={media.__typename + media.id}
            // TODO: Replace to `thumbnail`
            src={getCdnAssetUrl(media.src)}
            width={10}
            height="auto"
            setDimensions={(dimensions) =>
              setPhotos((list) =>
                [
                  ...list,
                  {
                    ...dimensions,
                    ...media,
                    isVideo: media.__typename === 'videos',
                  },
                ].sort(sort('timestamp')),
              )
            }
          />
        ))}
      </div>
      {photos.length > 0 && (
        <MosaicView
          items={photos}
          onVideoEvent={(video, end = false) => {
            posttour(end ? events.pgve : events.pgvs, () => getMediaProps(video))
          }}
          onVideoOver50PercentEvent={(video) => {
            posttour(events.pgvo5p, () => getMediaProps(video))
          }}
          onEnlargeImage={(photo) => {
            posttour(events.pgie, () => getMediaProps(photo))
          }}
          onCloseImage={(index) => {
            const photo = photos[index]
            posttour(events.pgiec, () => getMediaProps(photo))
          }}
          onEnlargeImageView={(item) => {
            const { activeIndex } = item
            const photo = photos[activeIndex]
            posttour(events.pgeiv, () => getMediaProps(photo))
          }}
          onSlideChange={(item) => {
            const { activeIndex, previousIndex } = item
            const diff = activeIndex - previousIndex
            const photo = photos[activeIndex]
            if (diff === 1) posttour(events.pgnc, () => getMediaProps(photo))
            if (diff === -1) posttour(events.pgbc, () => getMediaProps(photo))
          }}
        />
      )}
    </>
  )
}
